<div id="doctors-list" class="flex flex-col gap-3">

  <div>
    <a class="cursor-pointer flex flex-row" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      <p>Back</p>
    </a>
  </div>
  <div id="doctors-list-header" class="flex flex-row justify-between">
    <p>Patient Name</p>
    <p>Patient ID</p>
  </div>
  <mat-divider></mat-divider>
  <div class="body flex flex-col gap-3">
    @if (!!patients) {
      @for (patient of patients; track patient['id']) {
        <div class="custom-btn rounded-lg" (click)="openPatient(patient)">
          <div class="flex flex-row justify-between p-3 cursor-pointer">
            <p>{{ patient.first_name }}</p>
            <p>{{ patient.id }}</p>
          </div>
        </div>
      }
    } @else {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </div>
</div>
